module.exports = __webpack_public_path__ + "img/b8957fa40a7d4f738b2e8a283d8ee574-1024.25ed7a4b.jpg";